import React, { useState } from "react";

import {  Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CheckPaymentDetailsPaymentInquiryCriteriaBean,
  CheckPaymentHistoryPrintRequest,
  CustomerSearchCriteria,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupARModule, PopupInvoiceModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
class CardPaymentHistory extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Card Payment History Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new CheckPaymentDetailsPaymentInquiryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      isShowARModule: false,
      moduleForPopup: [],
      inquiryData: null,
      checkAppliedInvoiceList: [],
      creditMemoAppliedInvoiceList: [],
      creditMemoList: [],
      reversedCheckList: [],
      creditMemoData: null,
      customerCreditDetails: [],
      customerData: null,
      cardLookupHandler: null,
      isShowCardLookup: false,
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      isDisableFields: false,
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
        isShowCardLookup: false,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readCustomerResponse = (response) => {
    let customerData = response.data.customer;
    if (customerData != null) {
      let customerCreditDetails = [];
      if (!isEmptyArray(customerData.customerCreditCards)) {
        customerData.customerCreditCards.map((list) => {
          let cardBean = new BaseBean();
          cardBean.code = list.cardNumber.substr(-4);
          cardBean.description = list.cardType;
          customerCreditDetails.push(cardBean);
        });
        this.state.cardLookupHandler = null;
        let cardLookupHandler = new GenericAttributeLookupHandler(
          customerCreditDetails,
          "Card"
        );
        this.setState({
          cardLookupHandler: cardLookupHandler,
          isShowCardLookup: true,
        });
        this.setState({ customerCreditDetails: customerCreditDetails });
      }
      let criteria = this.state.criteria;
      criteria.customerCode = customerData.code;
      criteria.customerName = customerData.description;
      this.setState({ customerData: customerData, criteria: criteria });
    }
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomer(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    if (
      !isEmptyString(criteria.customerCode) &&
      !isEmptyString(criteria.cardNumber)
    ) {
      this.loadCardPaymentInquiryList(criteria);
    } else {
      let errMsg = "Invalid Input Criteria";
      let errorList = [];
      errorList.push(errMsg);
      this.setState({
        alertMessage: errorList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadCardPaymentInquiryList = (criteria) => {
    if (SecurityAccessManager.CardPaymentHistoryInquiry_IsAccessible()) {
      ReportService.inquireCheckPaymentHistoryReport(
        criteria,
        this.cardPaymentInquiryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  cardPaymentInquiryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let inquiryData = response.data.result.infoBean;
      let checkAppliedInvoiceList = [];
      let creditMemoAppliedInvoiceList = [];
      if (!isEmptyArray(response.data.result.checkAppliedInvoices)) {
        checkAppliedInvoiceList = response.data.result.checkAppliedInvoices;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      if (!isEmptyArray(response.data.result.creditMemoAppliedInvoices)) {
        creditMemoAppliedInvoiceList =
          response.data.result.creditMemoAppliedInvoices;
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryDataList: checkAppliedInvoiceList,
        inquiryData: inquiryData,
        isShowClearCriteriaButton: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new CheckPaymentDetailsPaymentInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({ criteria: criteria, isShowCardLookup: false });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new CheckPaymentDetailsPaymentInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowCardLookup: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CheckPaymentHistoryPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CardPaymentHistoryInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateCheckPaymentHistoryPrintReport(
          listRequest,
          this.generateCheckPaymentPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CardPaymentHistoryInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateCheckPaymentHistoryPrintReport(
          listRequest,
          this.generateCheckPaymentPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCheckPaymentPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
    generateCheckPaymentPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
              window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewARModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowARModule: true,
          moduleForPopup: (
            <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowARModule: isOpen,
      moduleForPopup: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("AR#", "accountReceivableNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewARModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenInvoiceAmt", "openInvoiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalAppliedAmt", "totalAppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AppliedAmt", "apppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CM Applied", "creditMemoAppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  creditInquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("AR#", "accountReceivableNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewARModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "customcustomerPurchaseOrderNumbererCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenInvoiceAmt", "openInvoiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalInvoiceAmt", "totalInvoiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AppliedAmt", "appliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CM Applied", "creditMemoAppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let inquiryData = this.state.inquiryData;
    let creditMemoAppliedInvoiceList = this.state.creditMemoAppliedInvoiceList;
    let creditMemoData = this.state.creditMemoData;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeRef={this.customerCodeRef}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
        />
        {this.state.isInquiryDatasFound && (
          <div>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>AR#</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <InputTextbox
                  value={inquiryData.accountReceivableNumber}
                  className="summary_input text-right"
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>ExpiryMonth</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <InputTextbox
                  value={inquiryData.expiryMonth}
                  className="summary_input text-right"
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>ExpiryYear</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <InputTextbox
                  value={inquiryData.expiryYear}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Card Amount</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <NumberFormatInputbox
                  value={inquiryData.cardAmount}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {creditMemoData != null && (
                  <div className="header_div col-md-12 col-lg-12">
                    <FormLabel>OverPaid CreditMemo Details</FormLabel>
                    <br />
                    <Row className="d-flex justify-content-left">
                      <Col sm="1">
                        <FormLabel>CreditMemo#</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={creditMemoData.creditMemoNumber}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        {" "}
                        <FormLabel>Status</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={creditMemoData.status}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        {" "}
                        <FormLabel>Amount</FormLabel>
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          value={creditMemoData.amount}
                          decimalScale={2}
                          disabled={true}
                          className="summary_input text-right"
                        />
                      </Col>
                      <Col sm="1">
                        {" "}
                        <FormLabel>Applied Amount</FormLabel>
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          value={creditMemoData.appliedAmount}
                          decimalScale={2}
                          disabled={true}
                          className="summary_input text-right"
                        />
                      </Col>
                    </Row>
                  </div>
                )}
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <FormLabel> CardApplied Invoice Details</FormLabel>
              </Col>
              <Col sm="6">
                <FormLabel> CreditMemo Applied Invoice Details</FormLabel>
              </Col>
            </Row>
            <div className="div_inline">
              <div className="div_Equal_no_overflow">
                <div className="mt-3">
                  <CustomTable
                    data={inquiryDataList}
                    columns={this.inquiryColumns()}
                    label={"CardApplied Invoice Details"}
                  />
                </div>
              </div>
              <div className="div_Equal_no_overflow">
                <div className="mt-3">
                  <CustomTable
                    data={creditMemoAppliedInvoiceList}
                    columns={this.creditInquiryColumns()}
                    label={"CreditMemo Applied Invoice Details"}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  let criteria = props.criteria;
  let customerLookupHandler = props.customerLookupHandler;
  const customerCodeRef = props.customerCodeRef;
  let cardLookupHandler = props.cardLookupHandler;
  let isShowCardLookup = props.isShowCardLookup;
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  let isInquiryDatasFound = props.isInquiryDatasFound;
  let inquiryData = props.inquiryData;
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>CustomerCode</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={true}
            lookupHandler={customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>CardNumber</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="cardNumber"
            onChange={onChange}
            value={criteria.cardNumber}
            lookupRequired={isShowCardLookup}
            lookupHandler={cardLookupHandler}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        {isInquiryDatasFound && (
          <Row>
            <Col sm="3">
              <FormLabel>CardType</FormLabel>
            </Col>
            <Col sm="5">
              <InputTextbox
                onChange={onChange}
                value={inquiryData.cardType}
                disabled={true}
              />
            </Col>{" "}
          </Row>
        )}
      </Row>
    </div>
  );
}
function CardPaymentHistoryInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CardPaymentHistory {...props} name="" /> <br />
    </div>
  );
}

export default CardPaymentHistoryInquiry;
